import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import React from "react";
import ReactDOM from "react-dom";
import store from "./ApplicationStore.js";
import { applyThemePreviewBootstrapSync } from "./theme-system/themePreviewStorage.js";
import App from "./app.jsx";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import "./bootstrapLangFromUrl.js";
import "./localization/i18n.js";

// css
import "bootstrap/dist/css/bootstrap.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "react-quill/dist/quill.snow.css";
import "codemirror/lib/codemirror.css";
import "codemirror/theme/material.css";
import "simple-line-icons/css/simple-line-icons.css";
import "flag-icon-css/css/flag-icon.min.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "./scss/react.scss";
import "bootstrap-social/bootstrap-social.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import "react-datetime/css/react-datetime.css";
import "react-datepicker/dist/react-datepicker.css";

//js
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";

import "./index.css";

// ========================================

(() => {
  // `?lang=` is handled in bootstrapLangFromUrl.js (before i18n loads).

  (() => {
    // Keep Telegram-safe window.open for internal app links only
    function isTelegramMiniApp() {
      return Boolean(
          window.Telegram?.WebApp?.initData &&
          window.Telegram?.WebApp?.initDataUnsafe?.user
      );
    }

    // ✅ Keep Telegram-safe window.open for internal app links only
    (function () {
      const originalOpen = window.open;
      window.open = function (url, target, features) {
        const isTelegram = isTelegramMiniApp();
        const currentOrigin = window.location.origin;

        // Log for debugging
        //console.log("window.open override:", { url, isTelegram, currentOrigin });

        // Parse target URL safely
        let targetUrl;
        try {
          targetUrl = new URL(url, currentOrigin);
        } catch (err) {
          console.error("URL parse failed:", err);
          return originalOpen.call(window, url, target || "_blank", features);
        }

        const isSameOrigin = targetUrl.origin === currentOrigin;

        // 🟢 Only handle same-origin links within Telegram
        if (isTelegram && isSameOrigin) {
          //console.log("Opening same-origin page inside Telegram WebApp");
          window.location.href = targetUrl.href;
          return null;
        }

        // 🌍 For all other cases (external / Telegram games)
        // let the backend Start() handle tg.openLink or window.open logic
        return originalOpen.call(window, url, target || "_blank", features);
      };
    })();
  })();

})();

if (typeof window !== "undefined") {
  applyThemePreviewBootstrapSync();
}

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById("root")
);
